<script type="text/javascript">
	import { onMount, createEventDispatcher } from "svelte"
	import { get, writable } from "svelte/store"

	import API from "../../API/API"
	import AdminStore from "./Store"

	import Image from "../../Models/Image"
	import ImageCollection from "../../Models/ImageCollection"
	import ImageCollectionCategory from "../../Models/Enums/ImageCollectionCategory"
	import ImageCollectionVisibility from "../../Models/Enums/ImageCollectionVisibility"
	import LoadState from "../../Enums/LoadState"

	import Form from './Form.svelte';
	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Select, {Option} from '@smui/select';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import Icon from "@smui/textfield/icon/index";
	import SpinnerButton from "./SpinnerButton.svelte";

	import ValidationHelper from "../../Helpers/ValidationHelper";
	import { formatUnixTimestamp } from "../../Helpers/Misc/timeHelper";

	import UserHelper from "../../Branding/User"
	import Feature from "../../Branding/Feature"

	export let imageCollection = null; // ImageCollection Model

	let categories = Object.keys(ImageCollectionCategory);
	let visibilities = Object.keys(ImageCollectionVisibility);

	const dispatch = createEventDispatcher(); // submit | reset | delete

	const Loading = {
		NONE: -1,
		SAVING_COLLECTION: 0,
		DELETING_COLLECTION: 2
	};

	let images = AdminStore.cms.images;
	let imageSearchString = writable("");
	let imageSearchResults = writable([]);
	let updateImageSearchResults = () => {
		$imageSearchResults = [];
		if ($imageSearchString.length === 0) {
			return;
		}

		let useString = $imageSearchString.toLowerCase();

		for (let i = 0; i < $images.length; i++) {
			let image = $images[i];
			let stringMatch = image.name.toLowerCase().indexOf(useString) >= 0 ||
							  image.fileName.toLowerCase().indexOf(useString) >= 0;
			if (stringMatch && editable.image_ids.indexOf(image.id) === -1) {
				$imageSearchResults = [...$imageSearchResults, image];
			}
		}
	};
	$: {
		$imageSearchString;
		updateImageSearchResults();
	}

	let companies = AdminStore.cms.companies;
	let companySearchString = writable("");
	let companySearchResults = writable([]);
	let updateCompanySearchResults = () => {
		$companySearchResults = [];
		if ($companySearchString.length === 0) {
			return;
		}

		let useString = $companySearchString.toLowerCase();

		for (let i = 0; i < $companies.length; i++) {
			let company = $companies[i];
			let stringMatch = company.name.toLowerCase().indexOf(useString) >= 0;
			if (stringMatch && editable.company_ids.indexOf(company.id) === -1) {
				$companySearchResults = [...$companySearchResults, company];
			}
		}
	};
	$: {
		$companySearchString;
		updateCompanySearchResults();
	}

	let createEditable = (imageCollection) => {
		let obj = {
			name: imageCollection.name,
			category: imageCollection.category,
			image_ids: [...imageCollection.imageIds],
			company_ids: [...imageCollection.companyIds],
			visibility: imageCollection.visibility
		};
		return obj;
	};
	let editable = createEditable(imageCollection);

	let form = null;
	let loading = writable(Loading.NONE);


	let style = "width:100%;margin-top:10px;";
	$: if (form) form.setReadOnly($loading != Loading.NONE);

	let onReset = () => {
		editable = createEditable(imageCollection);
		updateImageSearchResults();
		updateCompanySearchResults();
		console.log("init/reset editable", imageCollection, editable);
		dispatch('reset');
	}
	let onCategoryChanged = () => {

	};
	let onVisibilityChanged = () => {

	};

	let findImage = (imageId) => {
		return AdminStore.helpers.getImageById(imageId);
	};
	let findCompany = (companyId) => {
		return AdminStore.helpers._getItemByProperty("id", companyId, AdminStore.cms.companies);
	};
	let addImage = (image) => {
		editable.image_ids.push(image.id);
		editable = editable;
		updateImageSearchResults();
	};
	let removeImage = (image) => {
		editable.image_ids.splice(editable.image_ids.indexOf(image.id), 1);
		editable = editable;
		updateImageSearchResults();
	};
	let addCompany = (company) => {
		editable.company_ids.push(company.id);
		editable = editable;
		updateCompanySearchResults();
	};
	let removeCompany = (company) => {
		editable.company_ids.splice(editable.company_ids.indexOf(company.id), 1);
		editable = editable;
		updateCompanySearchResults();
	};

	let onSubmit = () => {
		let data = editable;
		console.log("data", data);

		// We only want to send the info that has changed... I think...
		let n = imageCollection.isNew();
		let url = n ? "admin/image-sets/create" : "admin/image-sets/" + imageCollection.id;
		$loading = Loading.SAVING_COLLECTION;
		API.put(url, data)
			.then((response) =>{
				console.log("response", response);
				if (imageCollection.isNew()) {
					AdminStore.actions.addImageCollection(imageCollection);
				}
				imageCollection.setData(response);
				imageCollection = imageCollection;
				onReset();
				form.snackbar.start("Image Collection " + (n ? "created" : "updated") + " successfully.", "success");
				dispatch('submit', {imageCollection});
			}).catch((e)=>{
				console.error(e);
				form.snackbar.start("Image Collection " + (n ? "creation" : "update") + " failed.", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	};
	let onDelete = () => {
		AdminStore.cms.confirmDialog.onConfirm = () => {
			console.log('confirm');
			$loading = Loading.DELETING_COLLECTION;
			API.delete("admin/image-sets/" + imageCollection.id)
				.then((response)=>{
					console.log(response);
					form.snackbar.start("Image Collection deleted successfully.", "success");
					AdminStore.actions.deleteImageCollection(imageCollection);
					dispatch('delete');
				})
				.catch(()=>{
					form.snackbar.start("Image Collection deletion failed.", "error");
				})
				.finally(()=>{
					$loading = Loading.NONE;
					AdminStore.cms.confirmDialog.visible.set(false);
				});
		};
		AdminStore.cms.confirmDialog.visible.set(true);
		return;
	}

	onMount(()=>{
		onReset();
		updateImageSearchResults();
		updateCompanySearchResults();
	});
</script>

<style type="text/css">
	.image-upload-preview {
		border:1px dashed #888;
	}
</style>

<Form bind:this={form} id='admin-image-form'>
	{#if imageCollection.isNew()}
		<h2>New Image Collection</h2>
	{:else}
		<h2>Existing Image Collection</h2>
	{/if}

	<DataTable table$aria-label="Image Collection" table$class={"mdc-data-table__table w-100"}>
		<Head style="display: none">
			<Row>
				<Cell></Cell>
				<Cell></Cell>
			</Row>
		</Head>
		<Body>
			<Row>
				<Cell>Name</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.name} style="width:100%" />
				</Cell>
			</Row>
			<Row>
				<Cell>Category</Cell>
				<Cell>
					<select class='default' bind:value={editable.category} on:change={onCategoryChanged}>
						{#each categories as categoryKey}
							<option
								value={ImageCollectionCategory[categoryKey]}
								selected={editable.category === ImageCollectionCategory[categoryKey]}>
									{ImageCollectionCategory[categoryKey]}
							</option>
						{/each}
					</select>
				</Cell>
			</Row>
			<Row>
				<Cell>Images</Cell>
				<Cell>
					<div class='mt-10'>
						<Textfield dense variant="outlined" bind:value={$imageSearchString} style="width:100%" label="Search by name/filename..."/>
					</div>

					{#if $imageSearchString.length > 0}
						{#if $imageSearchResults.length === 0}
							<div class='msgbox bg-info mt-10'>
								No results.
							</div>
						{:else}
							{#each $imageSearchResults as image}
								<p on:click={()=>{ addImage(image) }}>{image.name} - {image.fileName} - {image.readableSize}</p>
							{/each}
						{/if}
					{/if}
					<hr/>
					{#if editable.image_ids.length > 0}
						<ul>
							{#each editable.image_ids as image_id}
								<li>
									{findImage(image_id).name} ({findImage(image_id).fileName}) (<a on:click|preventDefault={()=>{ removeImage(findImage(image_id)); }} href=":;">remove</a>)
								</li>
							{/each}
						</ul>
					{:else if editable.image_ids.length === 0}
						<div class='msgbox mb-10'>No images attached.</div>
					{/if}

				</Cell>
			</Row>
			<Row>
				<Cell>Visibility</Cell>
				<Cell>
					<select class='default' bind:value={editable.visibility} on:change={onVisibilityChanged}>
						{#each visibilities as visibilityKey}
							<option
								value={ImageCollectionVisibility[visibilityKey]}
								selected={editable.visibility === ImageCollectionVisibility[visibilityKey]}>
									{ImageCollectionVisibility[visibilityKey]}
							</option>
						{/each}
					</select>
				</Cell>
			</Row>
			{#if editable.visibility === ImageCollectionVisibility.ACL_PUBLIC ||
				 editable.visibility === ImageCollectionVisibility.ACL_PRIVATE}
				 <Row>
					<Cell>Access Control</Cell>
					<Cell>
						
						{#if !UserHelper.hasAnyOfFeatures([ Feature.ADMIN.COMPANIES.VIEW, Feature.ADMIN.COMPANIES.EDIT, Feature.ADMIN.EDIT ]) }
							<div class='msgbox bg-error'>You do not have permission to edit Access Control. You need permission to 'view companies'.</div>
						{:else}

							<div class='mt-10'>
								<Textfield dense variant="outlined" bind:value={$companySearchString} style="width:100%" label="Search company by name..."/>
							</div>
							{#if $companySearchString.length > 0}
								{#if $companySearchResults.length === 0}
									<div class='msgbox bg-info mt-10'>
										No results.
									</div>
								{:else}
									{#each $companySearchResults as company}
										<p on:click={()=>{ addCompany(company) }}>{company.name}</p>
									{/each}
								{/if}
							{/if}

							<hr/>

							{#if editable.company_ids.length > 0}
								<ul>
									{#each editable.company_ids as company_id}
										<li>{findCompany(company_id).name} - (<a on:click|preventDefault={()=>{ removeCompany(findCompany(company_id)); }} href=":;">remove</a>)</li>
									{/each}
								</ul>
							{:else if editable.company_ids.length === 0}
								<div class='msgbox mb-10'>No company has access.</div>
							{/if}
						{/if}

					</Cell>
				</Row>
			{/if}
		</Body>
	</DataTable>

	{#if $loading === Loading.SAVING_COLLECTION}
		<SpinnerButton style={style}/>
	{:else}
		<Button on:click={onSubmit} disabled={false} color="primary" variant="unelevated" style={style}><Label>{((imageCollection.isNew())?"Add Image Collection":"Update Image Collection")}</Label></Button>
	{/if}

	<Button on:click={onReset} color="primary" class="bg-info" variant="unelevated" style={style}><Label>Reset</Label></Button>

	{#if !imageCollection.isNew()}
		<!-- <h2 style={style}>Actions</h2> -->
		<hr style={style}/>

		{#if $loading === Loading.DELETING_COLLECTION || $loading === Loading.DISABLING_COLLECTION}
			<SpinnerButton style={style}/>
		{:else}
			<Button color="secondary" variant="unelevated" class="bg-error" on:click={onDelete} style={style}><Label>Delete Image Collection</Label></Button>
		{/if}
	{/if}


</Form>
